/**
 * Prefer same-origin /api in dev (CRA proxy) and production; override with REACT_APP_API_BASE if needed.
 * Build relative paths with `apiRoutes` so they stay aligned with `server/api.py`.
 */
export function apiUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${base}${p}`;
}
